import {
  Box,
  Button,
  Grid,
  Typography,
  InputAdornment,
  TextField,
  useTheme,
  TablePagination,
  Theme,
  Dialog,
  IconButton,
  DialogContent,
  DialogActions,
  Radio,
  ClickAwayListener,
  Skeleton,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  LinearProgress,
  CardMedia,
  Badge
} from '@mui/material';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Link as RouterLink } from 'react-router-dom';
import { CommonLayout, CountryCodesDropDown } from '../commonComponents';
import { useHistory } from 'react-router';
import { Dispatch, SetStateAction, ChangeEvent, useEffect, useState, useRef } from 'react';
import { createApplication, getAllApplications, getApplicationDetails, updateApplication } from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationFilterType, CreateApplicationProps, VerifyOtpResponseBody, VerifyPanResponseBody } from '../../redux-store/types/api-types';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { useDebounce } from '../../utils/useDebounce';
import { DialogCloseIcon, InfoIconOutlined, SearchIcon } from '../../assets/SvgIcons';
import { APPLICATION_LISTING_STATUS, APPLICATION_RE_KYC_STATUS, fundTypes, IS_DOB_APPLICABLE_FOR_AMC } from '../../utils/constant';
import { emailRegex, individualPanRegex, nameWithNumberRegex, nonIndividualPanRegex, phoneRegExp, whiteSpaceOnlyRegex } from '../../utils/regex';
import { ColumnType, DataTable } from '../DataTable';
import { checkIfApplicationIsNonIndividual, futureAge, getCountryCodes, getFirstHolderName, getFirstHolderPan, getIndividualType, getUniqueIdentityText, isMinor, isOnboardingTypeMinor, maskInfo, maxAge, preventSpecialCharacters } from '../../utils/utilityFunctions';
import BreadCrum from '../../lib/BreadCrum';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { theme } from 'highcharts';
import { KeyValue } from '../ApplicationDetails/personalDetails';
import { Item, ItemDetails } from '../ApplicationDetails';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { Formik, FormikProps, FormikContextType, setNestedObjectValues, useFormikContext, FormikValues, FormikContext, validateYupSchema, yupToFormErrors, Form } from 'formik';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { SendEmail, verifyPan } from '../../redux-store/actions/onBoarding';
import { KycOsvSection, VerifyPanAadharAmlKycSection } from '../onboarding/enterPAN';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { LoadingButton } from '@mui/lab';
import { count } from 'console';
import { showError } from '../../redux-store/actions/auth';
import { useSnackbar } from 'notistack';
import UseRadioGroup from '../../lib/formik/Radio';
import { getFormattedISTDate, getFormattedISTDateString } from '../../utils/date';
import { FilterIcon } from '../../assets/SvgIcons';
import { FilterDropdown, initialFilters } from '../investors/filters';

interface Values {
  pan: string;
  dob: string;
  onboardingType: string;
  onboardingVia: string;
  countryNameAndCode: string;
  kycMethod: {
    selectedValue?: string;
    isOsvOpen: boolean;
  }
  name: string;
  emailId: string;
  mobile: string;
  isDataChanged: boolean;
  onboardingSubType: string;
  isBSEEnabled: boolean;
  onboardingApplicationType: string
}

interface FilterProps {
  filters: ApplicationFilterType,
  open: boolean,
  handleFiltersAnchorEl: () => void,
  filtersAnchorEl: boolean,
  setPage: React.Dispatch<React.SetStateAction<number>>,
  setFilters: React.Dispatch<React.SetStateAction<ApplicationFilterType>>
  handleFiltersAnchorElClose: () => void,
  distributorLoading: boolean,
  totalFilters?: number,
  setTotalFilters?: React.Dispatch<React.SetStateAction<number>>
}

interface KycMethod {
  isOsvOpen: boolean;
  selectedValue: string;
}

const getTableHeader = (): ColumnType[] => {
  return [
    {
      header: 'Application Number',
      label: 'customerId',
      valueGetter: (row: ApplicationProps) => row.applicationNumber || 'N/A',
    },
    {
      header: 'Investor Name',
      valueGetter: ({ applicants = [], onboardingType }: ApplicationProps) =>
        maskInfo(isOnboardingTypeMinor(onboardingType as string) ? applicants[0]?.minorName || 'N/A' : getFirstHolderName(applicants)) || 'N/A',
    },
    {
      header: 'Investor PAN',
      valueGetter: ({ applicants = [] }: ApplicationProps) => maskInfo(getFirstHolderPan(applicants) ?? '') || 'N/A',
    },
    {
      header: 'Investor Type',
      valueGetter: ({ applicants = [], onboardingType }: ApplicationProps) => getIndividualType(applicants[0]?.status ?? '', onboardingType ?? '') || 'N/A',
    },
    {
      header: 'Mode of Holding',
      renderCell: (row: ApplicationProps) => {
        return (
          <Typography
            sx={{
              textTransform: 'capitalize',
            }}>
            {row.modeOfHolding || 'Single'}
          </Typography>
        );
      },
    },
    {
      header: 'Re KYC Reason',
      valueGetter: (row: ApplicationProps) => row?.rekycReason ?? 'N/A',
    },
    {
      header: 'Re KYC Status',
      renderCell: (row: ApplicationProps) => {
        const { palette } = useTheme()
        return (
          <Box
            className={APPLICATION_RE_KYC_STATUS[row.rekycStatus ?? '']}
            sx={{
              '& .MuiTypography-root': {
                fontWeight: 500,
                // fontSize: 16,
                color: '#B78813',
              },
              '&.Pending .MuiTypography-root': {
                color: palette.primary[500],
              },
              '&.Completed .MuiTypography-root': {
                color: palette.success[500],
              },
              '&.Expired .MuiTypography-root': {
                color: palette.error[500],
              },
            }}>
            <Typography
              component={RouterLink}
              to={
                checkIfApplicationIsNonIndividual(row)
                  ? `/non-individual-application-details/${row.id}`
                  : `/application-details/${row.id}`
              }
              sx={{ textDecoration: 'none' }}>
              {`${APPLICATION_RE_KYC_STATUS[row.rekycStatus ?? '']}` || 'N/A'}
            </Typography>
          </Box>
        );
      },
    },

  ];
}

const routerPath = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    warning: true
  },
  {
    name: 'Re KYC Status',
    path: `/re-kyc-status`,
  },
]

function ReKYCDialog({ isDialogOpen, handleDialogClose, rowId, getApplication }: { isDialogOpen: boolean, handleDialogClose: () => void, rowId: string, getApplication: () => void }): JSX.Element {

  if (!isDialogOpen) return <></>;
  const theme = useTheme();
  const dispatch = useDispatch();
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const [currentStatus, setCurrentStatus] = useState<string>('');
  const [showInvestorKyc, setShowInvestorKYC] = useState<boolean>(false);
  const history = useHistory();

  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const formikRef = useRef<FormikProps<Values>>(null);
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);
  const [amlCheckPassed, setAmlCheckPassed] = useState(false)
  const [verifyPanApiCalled, setVerifyPanApiCalled] = useState(false);
  const [panVerificationToken, setpanVerificationToken] = useState('');
  const [applicantPanNumbers, setApplicantPanNumbers] = useState<string[]>([]);
  const [panVerificationResponse, setPanVerificationResponse] = useState<VerifyPanResponseBody>();
  const [values, setValues] = useState({
    pan: '',
    dob: '',
    onboardingType: 'individual',
    countryNameAndCode: 'India: +91',
    onboardingVia: 'digital',
    kycMethod: {
      selectedValue: "investor",
      isOsvOpen: false
    },
    name: '',
    mobile: '',
    emailId: '',
    isDataChanged: true,
    onboardingSubType: '',
    onboardingApplicationType: '',
    isBSEEnabled: false
  });
  const { enqueueSnackbar } = useSnackbar();
  const [kraPopup, setKraPopup] = React.useState<boolean>(false);

  const validationSchema1 = yup.object().shape({
    name: yup.string().when('onboardingType', {
      is: (value: string) => ['minor'].includes(value),
      then: yup.string().required('Full Name is required').matches(nameWithNumberRegex, 'Special Characters except .\'-()& not allowed'),
      otherwise: yup.string()
    }),
    pan: yup.string().uppercase()
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (!['minor'].includes(parent?.onboardingType)) {
          return true;
        }
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }
        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (
            (
              parent?.onboardingType === "individual" ||
              parent?.onboardingType === "minor"
            ) &&
            !individualPanRegex.test(fieldValue)
          ) {
            return createError({
              message: 'Only Individual PANs are allowed',
              path,
            });
          }

          if (
            parent?.onboardingType === "nonIndividual" &&
            (
              // To check whether the entered PAN is individual
              individualPanRegex.test(fieldValue) ||
              // To check the format for PAN entered
              !nonIndividualPanRegex.test(fieldValue)
            )
          ) {
            return createError({
              message: 'Only Non Individual PANs are allowed',
              path,
            });
          }
        }

        // if (!individualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'Only individual PANs are allowed',
        //     path,
        //   });
        // }
        // if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'invalid PAN',
        //     path,
        //   });
        // }
        // if (!nonIndividualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'invalid PAN',
        //     path,
        //   });
        // }
        if (fieldValue.split('')[3] === 'P' && applicantPanNumbers.includes(fieldValue)) {
          return createError({
            message: 'There is already same pan for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    dob: yup.string().nullable().test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (!['minor'].includes(parent?.onboardingType)) {
        return true;
      }
      if (IS_DOB_APPLICABLE_FOR_AMC) {
        if (!fieldValue) {
          return createError({
            message: 'Date of Birth is required',
            path,
          });
        }
        const date = new Date(fieldValue);
        if (isNaN(date.getTime())) {
          return createError({ path, message: 'Invalid Date format' });
        }
        if (futureAge(fieldValue || '')) {
          return createError({
            message: 'Invalid Date',
            path,
          });
        }
        if (isMinor(fieldValue || '') && parent.pan?.split('')[3] === 'P') {
          return createError({
            message: 'Age should be greater than 18',
            path,
          });
        }
        if (maxAge(fieldValue || '') && parent.pan?.split('')[3] === 'P') {
          return createError({
            message: 'Age should be less than 125',
            path,
          });
        }
      }

      return true;
    }),
    emailId: yup
      .string()
      .nullable()
      .when('onboardingType', {
        is: (value: string) => ['minor', 'others'].includes(value),
        then: yup.string().matches(emailRegex, 'invalid Email ID').required('Email is required'),
        otherwise: yup.string().notRequired(),
      }),
    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => !value,
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!['minor'].includes(parent?.onboardingType)) {
          return true;
        }
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => !value,
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!['minor'].includes(parent?.onboardingType)) {
            return true;
          }
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
  });

  useEffect(() => {
    (async function () {
      try {
        setDataLoading(true);
        const _application = (await dispatch(
          getApplicationDetails(rowId)
        )) as unknown as ApplicationProps;
        const {
          applicants = [],
        } = _application || {};

        setApplication(_application);
        setCurrentStatus(_application?.status?.toLowerCase());
        setValues({
          ...values,
          pan: _application?.applicants[0]?.minorPan ?? '',
          name: _application?.applicants[0]?.minorName ?? '',
          dob: _application?.applicants[0]?.minorDOB ?? '',
          emailId: _application?.applicants[0]?.email ?? '',
          mobile: _application?.applicants[0]?.mobile ?? '',
          countryNameAndCode: _application?.applicants[0]?.countryNameAndCode ?? '',
          onboardingType: _application?.onboardingType ?? '',
          onboardingVia: _application?.onboardingVia ?? '',
          kycMethod: {
            selectedValue: `${_application?.applicants[0]?.kycMethod ?? ''}`.toLowerCase() === 'osv' ? 'osv' : 'investor',
            isOsvOpen: `${_application?.applicants[0]?.kycMethod ?? ''}`.toLowerCase() === 'osv',
          },
          onboardingSubType: _application?.applicants[0]?.onboardingSubType === "individual" ? "Individual" : _application?.applicants[0]?.onboardingSubType ? _application?.applicants[0]?.onboardingSubType : _application?.applicants[0]?.status == 'Individual' ? 'Individual' : 'corporate',
          isBSEEnabled: _application?.isBSEEnabled ?? true,
          onboardingApplicationType: _application?.applicants[0]?.status === 'Non-Individual' ? 'non_individual' : "individual",
        })

        const applicantPanNumbers = applicants.map((applicant) => applicant.panNo !== undefined ? applicant.panNo : '').filter((panNo) => panNo !== '') || [];
        setApplicantPanNumbers(applicantPanNumbers);
      } catch (e) {
        console.log(e);
      } finally {
        setDataLoading(false);
      }
    })();
  }, [isDialogOpen, rowId]);

  const handleVerifyPan = async (values: Values) => {
    try {
      if (!formikRef.current) {
        return
      }
      setAmlAcknowledgementLoading(true);
      const { setTouched } = formikRef.current
      const errorsObj = await setTouched({
        pan: true,
        name: true,
        dob: true,
      }, true) ?? {}
      if (
        Object.keys(errorsObj)
          .filter(key => ['pan', 'name', 'dob']
            .includes(key)).some(key => key in errorsObj)
      ) {
        return
      }

      const {
        pan,
        dob,
        onboardingType,
        onboardingVia,
        kycMethod,
        name,
        onboardingApplicationType,
        onboardingSubType,
        isBSEEnabled
      } = values;
      const response = (await dispatch(
        verifyPan({
          pan,
          dob: getFormattedISTDate(dob) ?? dob,
          onboardingType: "normal", onboardingVia: onboardingVia, name, onboardingSubType, isBSEEnabled, onboardingApplicationType
        }, false)
      )) as unknown as VerifyPanResponseBody
      if (!response) return;

      setAmlCheckPassed(response.amlCheck);
      // if (response) {
      //   setpanVerificationToken(response.panVerificationToken)
      //   setPanVerificationResponse(response);
      //   setVerifyPanApiCalled(true)
      // }
      // if (!response.amlCheck) {
      //   setAmlFailedresponse(response.amlData.system_match[0]);
      //   return setAmlPopup({
      //     panVerificationToken: response.panVerificationToken,
      //     pan: pan,
      //     dob: dob,
      //   });
      // }
      if (!response) return;

      setPanVerificationResponse(response);
      setAmlCheckPassed(response.amlCheck);

      if (isBSEEnabled && !response.kraCheck) {
        setKraPopup(true);
        return;
      }

      setpanVerificationToken(response.panVerificationToken);
      setVerifyPanApiCalled(true);
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  }

  const handleSubmit = async (values: Values) => {
    const isDataChanged = formikRef?.current?.values?.isDataChanged;
    const kycMethodSelectedValue = formikRef?.current?.values?.kycMethod?.selectedValue;

    try {
      setSubmitLoading(true);
      const updatedApplicants = application?.applicants.map((applicant, index) => {
        if (index === 0) {
          return {
            ...applicant,
            kycMethod: isDataChanged ? kycMethodSelectedValue : application?.applicants[0]?.kycMethod,
          };
        }
        return {
          ...applicant,
        };
      })
      const response = (await dispatch(
        updateApplication({
          body: {
            ...application,
            status: isDataChanged ? kycMethodSelectedValue === 'osv' ? 'draft' : 'sent_to_investor' : 'completed',
            rekycStatus: isDataChanged ? 'pending' : 'completed',
            applicants: updatedApplicants
          },
          applicationId: rowId,
        })
      )) as unknown as ApplicationProps;
      if (!response) {
        setSubmitLoading(false);
        return;
      }
      getApplication();
      if (kycMethodSelectedValue === 'osv' && isDataChanged) {
        if (`${response?.applicants[0]?.status}`.toLowerCase() === 'non-individual') {
          history.push('non-individual-application/distributor-details', { ...(response ?? {}) });
        } else {
          history.push(`application/personal-details`, { ...(response || {}) });
        }
        handleDialogClose();
        setSubmitLoading(false);
      } else if (kycMethodSelectedValue === 'investor' && isDataChanged) {
        setShowInvestorKYC(true);
        setSubmitLoading(false);
      } else if (!isDataChanged) {
        enqueueSnackbar('ReKyc updated successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        handleDialogClose();
        setSubmitLoading(false);
      }

    } catch (e) {
      setSubmitLoading(false);
      console.error((e as Error).message);
    }
  };

  const handleMinorSubmit = async (values: Values) => {
    setSubmitLoading(true);
    const { countryNameAndCode = '', dob = '', emailId = '', name = '', kycMethod = { selectedValue: '', isOsvOpen: false }, mobile = '', onboardingType = '', onboardingVia = '',
      onboardingApplicationType,
      onboardingSubType,
      isBSEEnabled
    } = values;

    try {
      const response = (await dispatch(
        SendEmail({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          bypassOtp: true,
          kycMethod: kycMethod.selectedValue,
          dob: getFormattedISTDate(dob) ?? dob,
          name,
          accountType: "EXECUTIONARY",
          onboardingType: "individual",
          onboardingVia,
          onboardingApplicationType,
          onboardingSubType,
          isBSEEnabled
        })
      )) as unknown as VerifyOtpResponseBody;

      if (!response) return

      const { applicantVerificationToken } = response || {};

      const res = (await dispatch(
        createApplication({ applicantVerificationToken, id: rowId })
      )) as unknown as CreateApplicationProps;

      if (!res) return

      if (!res?.isSuccess) {
        dispatch(showError((res?.message ?? "") as string));
        return;
      }
      history.push('/application/rm-details', { ...(res?.application || {}) });
      return;
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleRedirectEdit = () => {
    history.push(`application/personal-details`, { ...(application || {}) });
  }

  const handleDateChange = (fieldName: string, selectedDate: any, setFieldValue: any) => {
    // setFieldValue(fieldName, selectedDate?.isValid() ? getFormattedISTDate(selectedDate) : "", true);
    setFieldValue(fieldName, getFormattedISTDate(selectedDate), true);
    setVerifyPanApiCalled(false);
    setpanVerificationToken('');
  }

  const handleFundTypeChange = (value: string) => {
    if (!formikRef.current) {
      return
    }

    const { setFieldValue } = formikRef.current;
    setVerifyPanApiCalled(false);
    setFieldValue("isBSEEnabled", value === "true")
  }

  const onKraSubmit = async () => {
    try {
      setAmlAcknowledgementLoading(true);
      setKraPopup(false);
      setpanVerificationToken(panVerificationResponse?.panVerificationToken ?? '');
      setVerifyPanApiCalled(true)

    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={isDialogOpen}
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '15px',
          backgroundColor: 'background.default',
          maxWidth: '900px',
          padding: '25px',
          m: 0,
        }
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h2" sx={{ fontWeight: 600 }}>
            RE-KYC Progress Info
          </Typography>
          <IconButton onClick={handleDialogClose}>
            <DialogCloseIcon />
          </IconButton>
        </Box>
        {
          dataLoading ? <LinearProgress /> : (
            <Box sx={{ mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Item sx={(theme: Theme) => ({
                    fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px', color: theme.palette.text.secondary, pb: '7px'
                  })}>{'Initiation Date'}</Item>
                  <ItemDetails sx={(theme: Theme) => ({
                    color: theme.palette.text.primary, textTransform: 'capitalize', fontWeight: '500'
                  })}> {dataLoading ? <Skeleton animation="wave" width={'140px'} /> : application?.createdAt ? dayjs(application?.createdAt).format('DD-MM-YYYY') : '-'}</ItemDetails>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Item sx={(theme: Theme) => ({
                    fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px', color: theme.palette.text.secondary, pb: '7px'
                  })}>{'Current Owner'}</Item>
                  <ItemDetails sx={(theme: Theme) => ({
                    color: theme.palette.text.primary, textTransform: 'capitalize', fontWeight: '500'
                  })}> {dataLoading ? <Skeleton animation="wave" width={'140px'} /> : ((isOnboardingTypeMinor(application?.onboardingType ?? '') ? application?.applicants[0]?.minorName : application?.applicants[0]?.name) ?? '')}</ItemDetails>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Item sx={(theme: Theme) => ({
                    fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px', color: theme.palette.text.secondary, pb: '7px'
                  })}>{'Re-KYC Reason'}</Item>
                  <ItemDetails sx={(theme: Theme) => ({
                    color: theme.palette.text.primary, textTransform: 'capitalize', fontWeight: '500'
                  })}> {dataLoading ? <Skeleton animation="wave" width={'140px'} /> : (application?.rekycReason ?? '-')}</ItemDetails>
                </Grid>

                <Grid item xs={12} sm={6} sx={{ mb: 4 }}>
                  <Item sx={(theme: Theme) => ({
                    fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px', color: theme.palette.text.secondary, pb: '7px'
                  })}>{'Re-KYC Status'}</Item>
                  <ItemDetails sx={(theme: Theme) => ({
                    color: theme.palette.text.primary, textTransform: 'capitalize', fontWeight: '500'
                  })}> {dataLoading ? <Skeleton animation="wave" width={'140px'} /> : (APPLICATION_RE_KYC_STATUS[application?.rekycStatus ?? ''] ?? '')}</ItemDetails>
                </Grid>
              </Grid>
              <Formik
                innerRef={formikRef}
                initialValues={values}
                validationSchema={validationSchema1}
                onSubmit={isOnboardingTypeMinor(values?.onboardingType ?? '') ?
                  handleMinorSubmit :
                  showInvestorKyc ?
                    handleDialogClose :
                    (application?.rekycStatus?.toLowerCase() == 'pending' && application?.applicants[0]?.kycMethod?.toLowerCase() == 'osv') ?
                      handleRedirectEdit :
                      handleSubmit}
              >
                {({ values, setFieldValue }) => (
                  <Form >
                    {!isOnboardingTypeMinor(values?.onboardingType || '') && application?.rekycStatus?.toLowerCase() !== 'pending' && !showInvestorKyc &&
                      <Grid item xs={12} sx={{ mb: 2, ml: 1 }}>
                        <RadioGroup
                          row
                          name="isDataChanged"
                          value={values?.isDataChanged}
                          onChange={(e) => setFieldValue('isDataChanged', e.target.value == 'true')}
                        >
                          <FormControlLabel value="true" control={<Radio />} label="Update Data" />
                          <FormControlLabel value="false" control={<Radio />} label="No Change in Data" />
                        </RadioGroup>
                      </Grid>
                    }
                    {(showInvestorKyc || (application?.rekycStatus?.toLowerCase() == 'pending' && application?.applicants[0]?.kycMethod?.toLowerCase() != 'osv')) ? (
                      <Typography variant="body_600" sx={{ mt: 4 }}>
                        {application?.majorApplicationID ? 'Re-KYC already initiated, Please proceed to application.' : 'KYC by Investor Selected, Investor will receive a mail to complete the KYC'}
                      </Typography>
                    ) : (application?.rekycStatus?.toLowerCase() == 'pending' && application?.applicants[0]?.kycMethod?.toLowerCase() == 'osv') ? (
                      <Typography variant="body_600" sx={{ mt: 4 }}>
                        {application?.majorApplicationID ? 'Re-KYC already initiated as KYC through OSV, Please proceed to application.' : 'KYC through OSV Selected, Please complete the process by editing the application'}
                      </Typography>
                    ) : ((values?.isDataChanged && application?.rekycStatus?.toLowerCase() !== 'pending') &&
                      (<>
                        {!isOnboardingTypeMinor(application?.onboardingType || '') && <KycOsvSection disabled={values?.onboardingApplicationType === "non_individual" ? 'osv' : panVerificationResponse?.isCkycAvailable ? 'investor' : ''} setPanVerificationToken={setpanVerificationToken} />
                        }
                        {isOnboardingTypeMinor(application?.onboardingType || '') &&
                          (<Grid container columnSpacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6} sx={{ mb: 2 }}>
                              <UseRadioGroup
                                name="isBSEEnabled"
                                items={fundTypes}
                                onChange={(e) => handleFundTypeChange(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }} />
                            <Grid item xs={12} md={6}>
                              <MFTextField
                                label={'Full Name*'}
                                name="name"
                                placeholder={'Full Name*'}
                                required
                                autoComplete="off"
                                onChange={(e) => {
                                  setFieldValue("name", e.target.value)
                                  setVerifyPanApiCalled(false);
                                  setpanVerificationToken('');
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sx={{ display: { xs: 'none', md: 'block' } }}>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <MFTextField
                                label={`${getUniqueIdentityText(company)?.panNumber}*`}
                                name="pan"
                                placeholder={`${getUniqueIdentityText(company)?.pan}`}
                                required
                                autoComplete="off"
                                inputProps={{ style: { textTransform: 'uppercase' } }}
                                sx={{ m: 0 }}
                                onChange={(e) => {
                                  setFieldValue("pan", e.target.value);
                                  setVerifyPanApiCalled(false);
                                  setpanVerificationToken('');
                                }}
                                endAdornment={
                                  (verifyPanApiCalled) ? (
                                    panVerificationResponse?.panAddharCheck && panVerificationResponse?.kraCheck ? (
                                      <CheckCircleIcon sx={{ color: theme.palette.customColors.greenTeal }} />
                                    ) : (
                                      <CancelIcon sx={{ color: theme.palette.error[500] }} />
                                    )
                                  ) : <></>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <TextDatePicker
                                name='dob'
                                label={'Date of Birth ( DD/MM/YYYY)*'}
                                placeholder=""
                                maxDate={new Date()}
                                disabled
                                customHandleChange={(selectedDate: any) => handleDateChange('dob', selectedDate, setFieldValue)}
                              />
                            </Grid>
                            <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', mb: 2 }}>
                              <LoadingButton variant='contained' loading={amlAcknowledgementLoading}
                                sx={{
                                  color: 'textDark.primary',
                                  backgroundColor: 'primary.500',
                                  padding: "10px",
                                  ...theme.typography.body_600
                                }}
                                onClick={() => handleVerifyPan(values)}
                                disabled={verifyPanApiCalled}
                              >
                                Verify Pan
                              </LoadingButton>
                            </Grid>
                            <Grid item xs={12}>
                              <VerifyPanAadharAmlKycSection checkStatus={{ amlCheck: panVerificationResponse?.amlCheck ?? false, ckycCheck: panVerificationResponse?.isCkycAvailable ?? false, panAddharCheck: panVerificationResponse?.panAddharCheck ?? false, kraCheck: panVerificationResponse?.kraCheck ?? false }} verifyPanApiCalled={verifyPanApiCalled} onboardingType={values?.onboardingType || ''} />
                            </Grid>
                            <Grid item xs={12}>
                              <KycOsvSection disabled={values?.onboardingType === 'nonIndividual' ? 'osv' : panVerificationResponse?.isCkycAvailable ? 'investor' : ''} setPanVerificationToken={setpanVerificationToken} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <MFTextField
                                label={'Mobile Number*'}
                                name="mobile"
                                placeholder="Enter Mobile number"
                                onKeyDown={(e) => {
                                  preventSpecialCharacters(e);
                                }}
                                startAdornment={
                                  <CountryCodesDropDown
                                    // ElementWidth={mobileElementWidth && mobileElementWidth}
                                    name={'countryNameAndCode'}
                                    value={values.countryNameAndCode || ''}
                                    disabled={false}
                                  />
                                }
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <MFTextField
                                autoComplete="off"
                                label={'Email ID*'}
                                name="emailId"
                                placeholder='Email ID'
                                required
                              />
                            </Grid>
                          </Grid>
                          )}
                      </>
                      )
                    )}
                    {isOnboardingTypeMinor(values?.onboardingType || '') && application?.rekycStatus?.toLowerCase() !== 'pending' && <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                      <InfoIconOutlined />
                      <Typography variant="subtitle_600" sx={{ ml: 1, color: 'text.secondary' }}>
                        Please Verify Pan before Initiating KYC
                      </Typography>
                    </Box>}
                    {
                      application?.rekycStatus?.toLowerCase() === 'pending' &&
                      <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <InfoIconOutlined />
                        <Typography variant="subtitle_600" sx={{ ml: 1, color: 'text.secondary' }}>
                          Re-KYC Already Initiated
                        </Typography>
                      </Box>
                    }
                    <DialogActions sx={{ width: '100%', mt: 1 }} >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Button
                            fullWidth
                            variant="outlined"
                            sx={(theme: Theme) => ({
                              color: 'primary.500',
                              backgroundColor: 'transparent',
                              borderColor: 'primary.500',
                              borderWidth: '0.5px',
                              borderStyle: 'solid',
                              padding: "10px",
                              "&:hover, &.Mui-focusVisible": {
                                borderColor: 'primary.600',
                                backgroundColor: "background.default"
                              },
                              ...theme.typography.body_600
                            })}
                            onClick={handleDialogClose}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <MFSubmitButton
                            disabled={submitLoading || dataLoading || (isOnboardingTypeMinor(values?.onboardingType || '') && !verifyPanApiCalled) || application?.rekycStatus?.toLowerCase() === 'pending'}
                            loadingEnable={submitLoading}
                            label={showInvestorKyc ? 'OK' : (application?.rekycStatus?.toLowerCase() == 'pending' && application?.applicants[0]?.kycMethod?.toLowerCase() == 'osv') ? 'Continue Editing' : 'Initiate Re-KYC'}
                          // variant="contained"
                          />
                        </Grid>
                      </Grid>
                    </DialogActions>
                  </Form>
                )
                }
              </Formik >
            </Box>
          )
        }
      </DialogContent>
      <Dialog
        open={kraPopup}
        maxWidth='sm'
        fullWidth
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '15px',
            backgroundColor: "background.paper",
            rowGap: "15px",
          },
        }}
      >
        <DialogContent sx={{ paddingTop: "25px" }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: '24px', height: '24px', mr: 2 }}
            />
            <Typography variant='h2' color="text.primary">KRA Verification Failed</Typography>
          </Box>
          <Typography variant='subtitle_400' color="text.secondary">
            {`${panVerificationResponse?.kraMessage || 'Your KRA is not verified.'}`}
          </Typography>
          {/* <Typography variant='subtitle_400' color="text.secondary" mt={1}>
                  Please verify your KRA to continue with MF Funds application.
                </Typography> */}
        </DialogContent>
        <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
          <Button
            variant="outlined"
            disabled={amlAcknowledgementLoading}
            onClick={() => setKraPopup(false)}
            sx={(theme: Theme) => ({
              ...theme.typography.body_500,
              color: theme.palette.text.secondary,
              flex: 1,
              border: `0.5px solid ${theme.palette.text.secondary}`,
              padding: "10px",
              "&:hover, &.Mui-focusVisible": {
                borderColor: theme.palette.text.secondary,
                backgroundColor: theme.palette.background.default
              }
            })}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={amlAcknowledgementLoading}
            sx={(theme: Theme) => ({
              ...theme.typography.body_500,
              flex: 1,
              color: theme.palette.textDark.primary,
              padding: "10px"
            })}
            onClick={onKraSubmit}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog >
  );
}

export default function ReKYCStatus(): JSX.Element {
  const history = useHistory();
  const { palette } = useTheme()
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const [noOfPages, setNoPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0)
  const [limit, setLimit] = useState(10);
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    diy: storeDIY,
    accountType: storeAccountType,
    onboardingType: storeOnboardingType,
    bseClientActivationStatus: storeBseStatus,
    rekycStatus: storeRekycStatus,
    reKycReason: storeRekycReason,
    applicationSentBack,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [currentPage, setPage] = useState(page);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [search, setSearch] = useState(storeSearch);
  const debounceSearchString = useDebounce(search, 500);
  const [applicationsListData, setApplicationsListData] = useState<ApplicationProps[]>([]);

  const [isDialogOpen, setDialogOpen] = useState<boolean>(false);
  const [rowId, setRowId] = useState<string>('');
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  const [totalFilters, setTotalFilters] = useState<number>(0);


  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(
      role,
      applicationSentBack ? storeStatus.replace('draft', 'draft_send_back') : storeStatus,
      storeApplicationType,
      storeModeOfHolding,
      storeDistributorId,
      storeDIY,
      storeAccountType,
      storeBseStatus,
      storeOnboardingType,
      storeRekycStatus,
      storeRekycReason
    )
  );
  const { applicationType, distributorId, status, modeOfHolding, diy, accountType, onboardingType, bseClientActivationStatus, rekycReason, rekycStatus } = filters;

  const theme = useTheme();

  useEffect(() => {
    setApplicationsListData(applicationsList);
  }, [applicationsList]);

  const getApplication = async () => {
    setLoading(true);
    setApplicationsList([]);
    try {
      const response = (await dispatch(
        getAllApplications({
          page: currentPage,
          search,
          applicationType: applicationType.toString(),
          distributorId: distributorId.toString(),
          status: status
            .toString()
            .replace('draft_send_back', 'draft')
            .replace('draft,draft', 'draft'),
          modeOfHolding: modeOfHolding.toString(),
          applicationSentBack:
            status.includes('draft_send_back') && !status.includes('draft') ? true : null,
          diy: diy?.toString(),
          accountType: accountType?.toString(),
          bseClientActivationStatus: bseClientActivationStatus?.toString(),
          onboardingType: onboardingType?.toString(),
          rekycStatus: rekycStatus.length > 0 ? rekycStatus.toString() : 'due,pending,expired,pending_from_mpower',
          reKycReason: rekycReason.toString()
        })
      )) as unknown as GetAllApplicantionsResponseBody;
      const { applications, pages, total, limit } = response || {};
      setApplicationsList(applications);
      setNoPages(pages);
      setTotalCount(total)
      setLimit(limit);
      setLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setLoading(false);
    }
  }

  useEffect(() => {
    getApplication()
  }, [currentPage, debounceSearchString, filters]);

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleSearchText = (event: ChangeEvent<HTMLInputElement>) => {
    const searchedText = event.target.value.replace(/^\s+/g, '').replace(/\s+/g, ' ');
    event.target.value = searchedText;
    setPage(1);
    if (whiteSpaceOnlyRegex.test(searchedText)) return;
    setSearch(event.target.value);
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  }
  const handleFiltersAnchorEl = async () => {
    try {
      setFiltersAnchorEl(true);
      // setDistributorLoading(true);
      // const distributorList = (await dispatch(
      //   getDistributorsListForFilters()
      // )) as unknown as Distributor[];
      // setDistributors(distributorList);
      setDistributorLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setDistributorLoading(false);
    }
  };

  const handleFiltersAnchorElClose = () => {
    setFiltersAnchorEl(false);
  };

  const additionalCell = {
    header: 'Action',
    renderEditDeleteCell: (row: ApplicationProps): JSX.Element => {

      const handleDialogOpen = () => {
        setDialogOpen(true);
        setRowId(row.id);
      }

      return (
        <>
          {`${row.rekycStatus ?? ''}`.toLowerCase() !== 'completed' ? <Button
            variant="outlined"
            sx={(theme: Theme) => ({
              color: 'textDark.primary',
              backgroundColor: 'primary.500',
              borderRadius: '8px',
              textTransform: 'none',
              padding: '4px 16px',
              minWidth: 'auto',
              border: 'none',
              whiteSpace: 'nowrap',
              ...theme.typography.body_500,
              '&:hover': {
                backgroundColor: 'primary.200',
                border: 'none',
              },
            })}
            onClick={handleDialogOpen}
          >
            Re - Initiate
          </Button > : '-'}
        </>
      );
    },
  };

  return (
    <CommonLayout>
      <>

        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: '10px' }}>
            <BreadCrum array={routerPath} />
          </Box>
          <Box sx={{ marginBottom: '20px', ml: '6px' }}>
            <Typography sx={{ color: 'text.primary' }} variant='h1'>Re-KYC Status</Typography>
          </Box>

          <Box
            sx={{
              borderRadius: '25px',
              overflow: 'hidden',
              backgroundColor: palette.background.paper,
              width: '100%',
            }}
          >
            <Grid
              container
              sx={{
                p: '35px 30px',
                pb: 0,
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                bgcolor: 'common.white',
              }}>
              <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                <Grid item>
                  <TextField
                    id="outlined-multiline-flexible"
                    value={search}
                    placeholder="Search Application"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearchText(e)}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '5px',
                        border: `1px solid ${palette.text.secondary}B2`,
                        height: '40px',
                        width: '100%',
                        maxWidth: '255px',
                        ...theme.typography.body_400,
                        background: 'transparent'
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#B2B2B2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#B2B2B2',
                        },
                      },
                      '& input': {
                        backgroundColor: 'transparent',
                      },
                      '& .MuiAutocomplete-option': {
                        backgroundColor: 'transparent',
                        '&[aria-selected]': {
                          backgroundColor: 'transparent',
                          color: '#000',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '25px', flexDirection: 'row' }}>
                  <FilterOptions {...{ filters, open: filtersAnchorEl, handleFiltersAnchorEl, handleFiltersAnchorElClose, filtersAnchorEl, distributorLoading, setPage, setFilters, setFiltersAnchorEl, totalFilters, setTotalFilters }} />
                </Grid>
              </Grid>
            </Grid>
            <Box sx={{
              width: '100%',
              overflowX: 'auto'
            }}>
              <DataTable
                isLoading={isLoading}
                tableHeader={[...getTableHeader(), additionalCell]}
                tableData={applicationsListData}
                rowCustomStyles={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '.MuiTableCell-body ': { color: palette.text.primary, fontWeight: 500 },
                  background: 'transparent',
                }}
                boxStyles={{ minWidth: 100 }}
              />

            </Box>
            {!!applicationsList?.length && (
              <TablePagination
                style={{
                  color: palette.text.primary[500],
                  fontSize: 16,
                  fontWeight: 500,
                  padding: '20px 35px 35px 35px',
                  // paddingLeft: '50px',
                  // paddingBottom: '48px'
                }}
                rowsPerPageOptions={[]}
                labelRowsPerPage=""
                component="div"
                count={totalCount}
                rowsPerPage={limit}
                page={currentPage - 1}
                onPageChange={(event, num) => setPage(num + 1)}
                // onRowsPerPageChange={(rowsPerPage) => console.log('rowsPerPage', rowsPerPage.target.value)}
                sx={{
                  color: palette.text.primary[500]
                }} />
              // <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              //   <Pagination
              //     count={noOfPages}
              //     page={currentPage}
              //     color="primary"
              //     onChange={handlePageChange}
              //   />
              // </Stack>
            )}
          </Box>
          {/* {!!applicationsList.length && (
            <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              <Pagination
                count={noOfPages}
                page={currentPage}
                color="primary"
                onChange={handlePageChange}
              />
            </Stack>
          )} */}
        </Box>
        <ReKYCDialog isDialogOpen={isDialogOpen} handleDialogClose={handleDialogClose} rowId={rowId} getApplication={getApplication} />
      </>
    </CommonLayout>
  );
}



const FilterOptions = (props: FilterProps): JSX.Element => {
  const { filters, open, handleFiltersAnchorEl, filtersAnchorEl, setPage, setFilters, handleFiltersAnchorElClose, distributorLoading, totalFilters, setTotalFilters } = props;
  const { palette } = useTheme()
  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;
  // console.log('filtersAnchorEl', filtersAnchorEl)

  return (
    <>
      <Box
        // aria-controls="filter-menu"
        // aria-haspopup="true"
        // aria-expanded={open ? 'true' : undefined}
        component={'button'}
        sx={{ display: 'flex', alignItems: 'center', gap: '10px', border: 'none', background: 'transparent', cursor: 'pointer' }} onClick={handleFiltersAnchorEl}>

        <Badge
          showZero
          badgeContent={totalFilters}
          sx={(theme: Theme) => ({
            '& .MuiBadge-badge': {
              right: 0,
              top: -3,
              backgroundColor: theme.palette.primary[500],
              color: theme.palette.common.white,
              ...theme.typography.subtitle_600
            },
          })}
        >
          <FilterIcon />
        </Badge>
        <Typography variant='body_400' sx={{ fontWeight: 500, color: palette.text.primary }}>Filters</Typography>
      </Box>

      {filtersAnchorEl && (
        <FilterDropdown
          filters={filters}
          onFiltersChange={(value) => {
            setPage(1);
            setFilters(value);
          }}
          anchorEl={filtersAnchorEl}
          handleClose={handleFiltersAnchorElClose}
          // distributors={distributors}
          loader={distributorLoading}
          setTotalFilters={setTotalFilters}
          showOnlyReKycFilters={true}
        />


      )}
    </>
  );
};